import { Component, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.css'],
})
export class SelectComponent implements AfterViewInit {
  @Input() disabled = false;
  @Input() required = false;
  @Input() noblank = false;
  @Input() tab = 1;
  @Input() focused = false;
  @Input() options: Array<any>;
  @Input() disabledOptions: Array<any>;
  @Input() label = '';
  @Input() placeholder = '';
  @Input() selected;
  @Input() smallSelect = false;
  @Input() headerSelect = false;
  @Input() id: string;
  @Output() selectedOption: EventEmitter<object> = new EventEmitter();

  public changed = false;

  ngAfterViewInit() {
    if (this.focused) {
      setTimeout(() => {
        document.getElementById(this.id).focus();
      }, 1);
    }
  }

  selectOption(option: {}) {
    this.changed = true;
    this.selected = null;
    this.selected = option;
    this.selectedOption.emit(option);
  }

  checkDisabled(optionValue: string): boolean {
    let disabled = false;
    if (this.disabledOptions) {
      for (let i = 0; i < this.disabledOptions.length; i++) {
        if (this.disabledOptions[i].value === optionValue) {
          disabled = true;
        }
      }
    }
    return disabled;
  }
}
